export default __webpack_public_path__ + "static/media/iva_m.c95cfee8.jpg";